export const AllLeadMaharashtraCities=[
    { id:'1',cityName:"Mumbai",},
    { id:'2',cityName:"Pune",},
    { id:'3',cityName:"Nagpur",},
    { id:'4',cityName:"Nashik",},
   ]
   export const AllLeadKarnatakaCities=[
    { id:'1',cityName:"Bangalore",},
    // { id:'2',cityName:"Pune",},
    // { id:'3',cityName:"Nagpur",},
    // { id:'4',cityName:"Nashik",},
   ]